/* todo: these should all be mixins */

/* this provides an interface to save because only one shape per note */
var ShapeBtn = require('./shapeButton'),
    $ = require('jquery');

module.exports = ShapeBtn.extend({
    iconCode: 0xe904,
    color: 'lightgreen', //todo: hex
    title: 'Save',
    clickAction: function(e) { //NOTE, SAME AS REDACTION
        e.stopImmediatePropagation();
        this.el.unmouseover().unmouseout(); /* remove event before destroy called, otherwise error on mouseout animate */
        $('#notesCollection .ok:first').trigger('click'); //todo: just quick proto
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/btn/saveSignature.js
 ** module id = 229
 ** module chunks = 0
 **/